import styled from '@emotion/styled';
import React from 'react';
import {
  background,
  border,
  color,
  compose,
  display,
  flexbox,
  layout,
  position,
  shadow,
  space,
  typography,
} from 'styled-system';
import { defineWithTheme } from '../../theming';
import { BaseListProps } from '../List';

export const OrderedList = styled('ol')<BaseListProps>(
  (_props) => `
    list-style: decimal;
    margin: 0;
    padding: 0;
    border: 0;
    vertical-align: baseline;
    font: inherit;
    margin-left: 20px;
  `,
  defineWithTheme('lists'),
  compose(
    background,
    border,
    color,
    display,
    flexbox,
    layout,
    position,
    shadow,
    space,
    typography,
  ),
);

export default OrderedList;
export type OrderedListProps = React.ComponentPropsWithRef<typeof OrderedList>;
